import { Box, Button, CircularProgress } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

interface ModalActionsProps {
  onCancelClick: () => void;
  onConfirmClick: () => void;
  confirmLabel?: string;
  cancelLabel?: string;
  disabled?: boolean;
  loading?: boolean;
  confirmButtonProps?: any;
  cancelButtonProps?: any;
  children?: any;
}

export const ModalActionsButtons: React.FC<ModalActionsProps> = ({
  children,
  onCancelClick,
  onConfirmClick,
  confirmLabel,
  cancelLabel,
  disabled = false,
  loading = false,
  confirmButtonProps = {},
  cancelButtonProps = {},
}) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: "flex",
        gap: 2,
        justifyContent: "flex-end",
        pt: 2,
      }}
    >
      <Button
        sx={{ width: "100px" }}
        variant="outlined"
        onClick={onCancelClick}
        disabled={loading}
        {...cancelButtonProps}
      >
        {cancelLabel ?? t("cancel")}
      </Button>

      <Button
        sx={{ width: "100px" }}
        variant="contained"
        type="submit"
        disabled={disabled || loading}
        onClick={onConfirmClick}
        startIcon={loading ? <CircularProgress size={20} /> : undefined}
        {...confirmButtonProps}
      >
        {confirmLabel ?? t("submit")}
      </Button>
    </Box>
  );
};
